<script lang="ts" module>
	const dividerLength = 8;
</script>

<option
	disabled
	class={[
		"text-fcrgray/50",
		"[@supports(appearance:base-select)]:hidden",
		" [@supports(appearance:base-select)]:[&+option]:border-fcrlightgray",
		"[@supports(appearance:base-select)]:[&+option]:border-t",
	]}
>
	{"─".repeat(dividerLength)}
</option>
